export default function VersionDependantStyles({ children, newVersion }) {
  if (newVersion) {
    import("../../App.css");
  } else if (!newVersion) {
    import("../../legacy-App.css");
  }

  return <>{children}</>;
}
